
import { create } from 'zustand';

export const useExercisesStore = create((set) => ({
    exercises: [],
    improvementActions: [],
    selectedExercise: null,
    stats: null,
    uniqueValues: {},

    loadingDetail: false,
    errorDetail: null,
    isSubmitting: false,

    paginationExercises: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false
    },
    paginationImprovement: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false
    },

    error: null,

    // Setters
    setExercises: (items) => set({ exercises: items }),
    setImprovementActions: (items) => set({ improvementActions: items }),
    setStats: (stats) => set({ stats: stats }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues: uniqueValues || {} }),
    setSelectedExercise: (item) => set({ selectedExercise: item }),

    setLoadingExercises: (loading) => set({ loadingExercises: loading }),
    setLoadingImprovement: (loading) => set({ loadingImprovement: loading }),
    setLoadingStats: (loading) => set({ loadingStats: loading }),
    setLoadingDetail: (loading) => set({ loadingDetail: loading }),
    setErrorDetail: (error) => set({ errorDetail: error }),
    setIsSubmitting: (isSubmitting) => set({ isSubmitting }),

    setPaginationExercises: (pagination) => set((state) => ({
        paginationExercises: { ...state.paginationExercises, ...pagination }
    })),
    setPaginationImprovement: (pagination) => set((state) => ({
        paginationImprovement: { ...state.paginationImprovement, ...pagination }
    })),

    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    clearSelectedExercise: () => set({ selectedExercise: null, errorDetail: null }),

    // UI Helpers
    selectedItem: null,
    openForm: (item = null) => set({ selectedItem: item }),
    closeForm: () => set({ selectedItem: null }),
}));
